<script>
import { mapActions, mapGetters } from 'vuex'
import StoreService from '@/services/StoreService'

export default {
  name: 'ComicsCard',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('user', ['isAuthorized']),

    productId () {
      return this.product?.id
    },

    productTitle () {
      return this.product?.title || ''
    },

    productCover () {
      return this.product?.images?.[0]
    },

    specs () {
      return this.product?.specifications
    },

    comicsType () {
      return this.specs?.find(spec => spec.key === 'type')?.value
    },

    isFavourite () {
      return this.product?.favourite
    }
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    openRegistrationModal () {
      if (!this.isAuthorized) {
        this.showModal({
          component: 'Auth',
          data: {
            mode: 'register'
          }
        })
      }
    },

    addToFavourites () {
      if (!this.isAuthorized) {
        this.openRegistrationModal()
      } else if (this.isFavourite) {
        StoreService.dropFavourite(this.$axios, this.productId)
        this.product.favourite = false
      } else {
        StoreService.addToFavourites(this.$axios, this.productId)
        this.product.favourite = true
      }
    }
  }
}
</script>

<template>
  <NuxtLink :class="$style.card" :to="localeLocation(`/marketplace/comics/${productId}`)">
    <div v-if="productCover" :class="$style.cover">
      <nuxt-img
        :class="$style.cover__img"
        :src="productCover"
        :alt="productTitle"
        loading="lazy"
        height="200"
        width="242"
        format="webp"
      />

      <div :class="$style.likeContainer" @click.stop.prevent="addToFavourites">
        <img v-if="!isFavourite" :class="$style.like" :src="require('~/assets/img/icons/heart.svg')" alt="like" />
        <img v-else :class="$style.like" :src="require('~/assets/img/icons/heart-active.svg')" alt="unlike" />
      </div>
    </div>

    <div :class="$style.body">
      <p :class="$style.title" :title="productTitle">
        {{ productTitle }}
      </p>

      <span v-if="comicsType" :class="$style.type">{{ comicsType }}</span>
    </div>
  </NuxtLink>
</template>

<style lang="scss" module>
.card {
  max-width: 100%;
  display: block;
  background: $blue-grey70;
  color: $white;
  padding: 12px 4px;
  border-radius: 8px;
  cursor: pointer;
}

.cover {
  position: relative;
  width: 100%;
  height: 228px;
  margin-bottom: 8px;

  &__img {
    display: block;
    margin: auto;
    width: max-content;
    max-width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
  }
}

.like {
  height: 24px;
  width: 24px;

  &Active {
    path {
      fill: $primary60;
    }
  }

  &Container {
    position: absolute;
    bottom: 12px;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $blue-grey60;
    border-radius: 8px;
    height: 40px;
    width: 40px;
    margin-left: 12px;
    cursor: pointer;
  }
}

.body {
  margin-top: 8px;
  padding: 0 8px;
}

.title {
  margin: 0 0 4px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}

.type {
  color: $blue-grey10;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
</style>
